/* eslint-disable no-console */
import { API } from '../constants/api.constants';
import { apiClient, apiEndpoint } from './api.services';

export const getUserProfileDetails = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.PROFILE_DETAILS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editUserProfileDetails = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.EDIT_PROFILE_DETAILS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const changeUserPassword = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.CHANGE_PASSWORD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierProfileDetails = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.GET_SUPPLIER_PROFILE}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editSupplierProfileDetail = async (data) => {
  const id = data.userId;
  const updatedData = { ...data };
  delete updatedData?.userId;
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.EDIT_SUPPLIER_PROFILE}/${id}`, updatedData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSupplierUserProfileDetails = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.GET_USER_DETAILS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editUserProfileDetail = async (data) => {
  const id = data.userId;
  const updatedData = { ...data };
  delete updatedData?.userId;
  try {
    return await apiClient.put(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.EDIT_USER_DETAILS}/${id}`, updatedData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setNewPassword = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.SET_PASSWORD}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCurrencyPermission = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.CURRENCY_PERMISSION}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// export const getTheSlugsUsedStorageService = async () => {
//   try {
//     return await apiClient.get(`${apiEndpoint}${API.USER_ACCOUNT_DETAILS.GET_STORAGE_USED_SLUGS}`);
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };
